import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FileService } from 'src/app/services/file.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-observations-user',
  templateUrl: './observations-user.component.html',
  styleUrls: ['./observations-user.component.scss'],
})
export class ObservationsUserComponent implements OnInit {
  @Input() meeting: any;
  public observation = '';
  public statesButtons = [
    {
      txt: 'ASISTIO',
      id: 3,
    },
    {
      txt: 'INCUMPLIO',
      id: 4,
    },
  ];
  public uploadedFiles: { id?: number; image: string }[] = [];
  private _statusId = undefined;

  constructor(
    private uiSv: UiServices,
    private httpSv: HttpService,
    private trSv: TranslateService,
    private fileSv: FileService
  ) {}

  ngOnInit() {
    this.observation = this.meeting.observations;
    this.uploadedFiles = this.meeting.images;
  }

  async changeState(ev: Event) {
    const evn = ev.target as HTMLIonSelectElement;
    const btn = this.statesButtons.find((b) => b.id === evn.value);

    this.meeting.status = btn.txt;
    this._statusId = btn.id;
  }

  async continue() {
    try {
      await this.uiSv.showLoading();
      const body = {
        status: this._statusId === 3 ? 'Asistencia' : 'Incumplimiento',
        observations: this.observation,
        id: this.meeting.id,
        meetingImages: this.uploadedFiles,
      };
      const res = await this.httpSv.itemAction(
        body,
        'operators/meetings',
        'update'
      );
      if (res.status) {
        const tr = this.trSv.instant('OBSERVACION_GUARDADA_CON_EXITO');
        this.uiSv.showToast(tr);
      }
      await this.uiSv.loading.dismiss();
    } catch (err) {
      await this.uiSv.loading.dismiss();
      console.error(err);
    }
  }

  async removeFile(index: number) {
    if (this.meeting.images[index].id) {
      try {
        await this.uiSv.showLoading();
        await this.httpSv.itemAction(
          { id: this.meeting.images[index].id },
          'meeting',
          'destroyImages'
        );
      } catch (error) {
        this.uiSv.showToast('Error al eliminar la imagen');
      } finally {
        await this.uiSv.loading.dismiss();
      }
    }
    this.uploadedFiles.splice(index, 1);
  }

  async uploadImages(ev: Event) {
    const files = (ev.target as HTMLInputElement).files;
    for (const key in files) {
      const element = files[key];
      if (element.name && element.size) {
        const response = await this.fileSv.uploadFile(
          'meetingImages',
          element,
          '',
          '',
          ev
        );
        this.uploadedFiles.push({ image: response });
      }
    }
  }
}
